module.exports = __webpack_public_path__ + "img/brightness-low.3269d2a9.svg";